import type { PortfolioListQuery } from "@pokifolio/contracts";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useApi } from "../../app/api-context";

export const PORTFOLIO_QUERY_KEY = ["portfolio"] as const;

export function usePortfolioList(query: PortfolioListQuery) {
  const api = useApi();
  return useQuery({
    queryKey: [...PORTFOLIO_QUERY_KEY, "list", query],
    queryFn: () => api.listPortfolio(query),
    placeholderData: keepPreviousData,
  });
}

export function usePortfolioItem(id: string) {
  const api = useApi();
  return useQuery({
    queryKey: [...PORTFOLIO_QUERY_KEY, "item", id],
    queryFn: () => api.getPortfolioItem(id),
  });
}

/** Any change to cards: lists and the card page refresh afterwards. */
export function usePortfolioChange<TArgs, TResult>(change: (args: TArgs) => Promise<TResult>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: change,
    onSettled: () => queryClient.invalidateQueries({ queryKey: PORTFOLIO_QUERY_KEY }),
  });
}
